var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 110 110",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.9799 0.000812996C85.3415 0.000812996 110 24.6143 110 55.0003C110 69.5923 104.137 83.5425 93.8555 93.885C83.5742 104.228 69.5983 110 54.9799 110C53.3736 110 51.7669 109.84 50.2411 109.679V79.2132C51.7669 79.5338 53.3736 79.6941 54.9799 79.6941C68.6347 79.4536 79.5583 68.1491 79.3172 54.5195C79.0762 41.2104 68.3131 30.467 54.9799 30.2265V20.766C73.9357 20.8461 89.2773 36.2397 89.1968 55.1606C89.1968 64.2205 85.5822 72.8794 79.1566 79.2933C73.9357 84.5045 67.1085 87.9519 59.719 88.9944V100.219C69.9999 99.0962 79.6384 94.4463 86.9478 87.1502C104.699 69.4317 104.699 40.7292 86.9478 23.091C69.1969 5.45267 40.4417 5.37249 22.7711 23.091C5.02009 40.8097 5.02009 69.5118 22.7711 87.1502C27.751 92.1212 33.775 95.8892 40.5221 98.2143V108.156C31.2851 105.59 22.8514 100.62 16.0241 93.885C-5.34137 72.3982 -5.34137 37.6829 16.0241 16.196C26.3052 5.77337 40.3615 -0.0793612 54.9799 0.000812996Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRose);
export default __webpack_public_path__ + "static/media/rose.873c91d6ea17ebe5b5061b025ac14458.svg";
export { ForwardRef as ReactComponent };